import { render, staticRenderFns } from "./TargaTelematicsVehicleDetails.vue?vue&type=template&id=f071e308&scoped=true"
import script from "./TargaTelematicsVehicleDetails.vue?vue&type=script&lang=js"
export * from "./TargaTelematicsVehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./TargaTelematicsVehicleDetails.vue?vue&type=style&index=0&id=f071e308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f071e308",
  null
  
)

export default component.exports